<!-- ==============================
    File Name: TableStriped.vue
    Description: Rendering default table with striped style
    -------------------------------
    
      
    
=============================== -->


<template>
    <vx-card title="Top 5 Partners">

        <vs-table stripe :data="partners">

            <template slot="thead">
                <vs-th>Company</vs-th>
                <vs-th>City</vs-th>
                <vs-th>Joined On</vs-th>
                <vs-th>Clients</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].CompanyName">
                        {{data[indextr].CompanyName}}
                    </vs-td>
                    <vs-td :data="data[indextr].City">
                        {{data[indextr].City}}
                    </vs-td>
                    <vs-td :data="data[indextr].CreatedDate">
                        {{data[indextr].CreatedDate}}
                    </vs-td>
                    <vs-td :data="data[indextr].ClientCount">
                        {{data[indextr].ClientCount}}
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
  </vx-card>
  </template>
<script>
import PartnerService from "@/services/PartnerService";
import UtilService from "@/services/UtilService";
export default {
  data () {
    return {
      partners: []
    }
  },
  methods: {
      getPartners() {
            if(this.userInfo){
              PartnerService.getAll(this.userInfo).on("value", (items) => {
                this.partners = [];
                this.totalPartnerCount = 0
                this.totalActivePartnerCount = 0
                items.forEach((item) => {
                  let key = item.key;
                  let data = item.val();
                    if(data['IsDeleted'] == 0){
                      data['CreatedDate'] = UtilService.convertUTCToCurrentZone(data['CreatedDate'],this.userInfo.Timezone)
                      this.totalPartnerCount += 1;
                      this.partners.push({...data});
                    if(data['Status']=='Active' || data['IsActive']==1){
                      this.totalActivePartnerCount += 1;
                    }
                  }
                });
                this.partners =  this.partners.sort(function(a,b){
                return (b.ClientCount - a.ClientCount)
                }).slice(0,5);
        
              });
            }
          }
  },
  created() {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.userInfo = userInfo;
    this.getPartners()
  }
}
</script>